import instance from './axiosInstance';

export const getIntegrationStatus = (options = {}, http = instance) => {
  return http.get('/appData/data-ingestion-status', options);
};

export const postIntegrationStatus = (reqBody, options = {}, http = instance) => {
  return http.post('/appData/data-ingestion-status', reqBody, options);
};
